<af-main-container [title]="'i18n_lib_breadcrumb#IncidentId' | translate :{incidentId: incident?.id || incidentId}"
                   [customLastBreadcrumb]="'i18n_lib_breadcrumb#IncidentId' | translate :{incidentId: incident?.id || incidentId}"
                   [buttonLabel]="showButton && ('i18n_af_buttonIncidentResolution' | translate)"
                   (buttonClickListener)="goToResolution()"
                   [navigateBackListener]="navigateBack"
                   spinnerIds="initial">
    @if (incident?.isDeleted) {
        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px"
             class="bc-secondary-red-100 radius-16 pt-16 pr-24 pb-16 pl-24 w-100 mt-24">
            <div class="t2-semi-bold">{{ 'i18n_af_labelIncidentDeletedReason' | translate : {reason: deletedBaseName} }}</div>
            <div class="t4">{{ incident.deletionReason }}</div>
        </div>
    }
    <div CustomTitle class="w-100 mr-16 ml-16" fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
        @if (incident) {
            <af-status [statusText]="incident.incidentStatus" [status]="statusStyle"/>
        }
        @if (!incident?.isDeleted && !isRestrictedAccess) {
            <div fxLayout="row" fxLayoutAlign="end center">
                @if (incident?.typeCode === 'FRAUD' && !authHolderService.hasAccess(['finance-user'])) {
                    <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_download_document"
                                [matTooltip]="'i18n_af_labelGenerateAnalyticAgentReport' | translate"
                                (click)="generateAnalyticReport()"/>
                }
                @if (!incident?.isInnocentStatus) {
                    <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_edit" [matTooltip]="'i18n_af_labelEdit' | translate"
                                (click)="editIncident()"/>
                }
                @if (!incident?.isInnocentStatus || authHolderService.hasAccess(['npck-admin'])) {
                    <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_delete"
                                [matTooltip]="'i18n_af_labelDelete' | translate"
                                (click)="deleteIncident()"/>
                }
            </div>
        }
    </div>
    <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxFlex>
        <af-info class="w-100 mt-24" [info]="info"/>
        @if (incident) {
            <mat-tab-group
                mat-align-tabs="start"
                animationDuration="0"
                fxFlex
                class="mt-16 w-100 h-100 overflow-y-scroll"
                [(selectedIndex)]="selectedTabIndex"
                (selectedIndexChange)="handleNavigation($event)">
                @for (tab of tabs; track tab) {
                    <mat-tab [label]="'i18n_af_' + tab | translate : {
            count: unreadInquiriesCount ? ' ('+unreadInquiriesCount+')' : ''
            }" class="text-center h-100">
                        <ng-template matTabContent>
                            @if (activeTab === tab) {
                                @if (tab === 'tabIncidentDetails') {
                                    <af-incident-details-tab
                                        [incident]="incident"
                                        [transactionId]="transactionId"
                                        class="mt-24 w-100 h-fit-content"
                                        fxFlex/>
                                }
                                @if (tab === 'tabResolutions') {
                                    <af-incident-resolution-tab [incidentId]="incidentId"
                                                                (reloadIncidentListener)="reloadIncident()"/>
                                }
                                @if (tab === 'tabContacts') {
                                    <af-contacts-tab [incident]="incident"/>
                                }
                                @if (tab === 'tabMsisdnFraudEntries') {
                                    <af-msisdn-fraud-entries-tab [incident]="incident"/>
                                }
                                @if (tab === 'tabCompromisedPaymentInstrument' || tab === 'tabTransactions') {
                                    <af-transactions-tab [incident]="incident"/>
                                }
                                @if (tab === 'tabRequests') {
                                    <af-incident-inquiries-tab [incident]="incident"
                                                               [inquiriesResponse]="inquiries"/>
                                }
                                @if (tab === 'tabHistory') {
                                    <af-entity-history [entityId]="incidentId" [entityType]="EntityType.INCIDENT" mode="full"/>
                                }
                                @if (tab === 'tabDocuments') {
                                    <af-documents-tab [incident]="incident"/>
                                }
                                @if (tab === 'tabRefunds') {
                                    <af-refunds-tab [incident]="incident" (createRefundListener)="navigateToCreateRefunds()"/>
                                }
                                @if (tab === 'tabAnalyticAgentReports') {
                                    <af-analytic-agent-reports-tab [incidentId]="incident.id"/>
                                }
                            }
                        </ng-template>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </div>
</af-main-container>
